<div class="o-flex o-flex--grids ">
    <div *ngFor="let button of buttons" class="o-flex__item u-flex-1/2@desktop u-flex-1/2@tablet u-flex-1/1@small pt-4">
        <app-button
                [id]="button.id"
                [label]="button.label"
                [description]="button.description"
                (click)="buttonClicked($event, button)"
                [imageSource]="button.imageSource"
                [class.active]="isActive(button)"
                [disabled]="disabled">
        </app-button>
    </div>
</div>
